import React from 'react';
import { Text } from '../Text/Text';
import { Button } from '../Button/Button';
import { Box } from '../Box/Box';
import { MarginProps } from '../../../theme/styledProps';

interface StatErrorProps extends MarginProps {
  message?: string;
  onRetry?(): void;
}

export const StatError: React.FC<StatErrorProps> = ({
  message = 'Sorry, something went wrong. Please try again.',
  onRetry,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      {...rest}
    >
      <Text color="neutral.500" mb={onRetry ? '16' : 0} textAlign="center">
        {message}
      </Text>

      {onRetry && (
        <Button variant="primary" onClick={onRetry}>
          Try Again
        </Button>
      )}
    </Box>
  );
};
